function formatDetail(detail: string): string {
  return detail.
    replace(/^request\./, '');
}

function formatDetails(details: any) {
  const res = [];
  if (Array.isArray(details)) {
    for (const det of details) {
      res.push(formatDetail(det));
    }
  } else {
    res.push(formatDetail(details));
  }
  return res;
}

function apiErr(response: any): any {
  // { "status": 422, "ts": "2019-08-06T11:46:53.243995287Z", "type": "ValidationError",
  // "msg": "Validation failed", "details": [["request.email required", "request.password required"]],
  // "req_id": "7eb56f4faaf1/PbTwflKfbr-000728" }
  const res: any = { msg: "", details: [] };
  if (response.data.msg) {
    res.msg = response.data.msg;
  }

  switch (response.status) {
    case 401: // unauthorized
      // res.msg = "Unauthorized: " + res.msg
      return res;
    case 400: // invalid data
      if (response.data.details) { res.details = formatDetails(response.data.details[0]); }
      return res;
    case 422: // Unprocessable Entity - type="ValidationError"
      if (response.data.details) { res.details = formatDetails(response.data.details[0]); }
      return res;
    case 404: // not found
      if (response.data.msg) { res.details = formatDetails(response.data.msg); }
      return res;
  }
  return response;
}

function format(err: any): any {
  const res = "";
  if (!err) { return; }


  // handle api response errors
  if (err.response && err.response.status && err.response.data) {
    return apiErr(err.response);
  }

  return { msg: "" + err };

  // if (err.response) {
  //   let res = err.response
  //   let data = res.data
  //   // if it has status code, then it should be an http request
  //   if (res.status) {
  //     switch (+res.status) {
  //       case 422: //Unprocessable Entity - type="ValidationError"
  //         res = "Invalid data received"
  //         if (data)
  //           res += "\n" + prettyData(data)
  //         return res
  //     }
  //   }


  //   if (err.response.data.type) {
  //     res += err.response.data.type;
  //   }

  //   if (err.response.data.msg) {
  //     res += (res ? ": " : "") + err.response.data.msg;
  //   }
  // } else if (err.code) {

  // } else {
  //   return err.response
  // }
}

export {
  format
};
